"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.patientCreationFeatures = void 0;
var patientCreationFeatures;
(function (patientCreationFeatures) {
    patientCreationFeatures["APP_IDENTIFIER_VALIDATION"] = "appIdentifierValidation";
    patientCreationFeatures["ERASURE_REQUEST_VALIDATION"] = "erasureRequestValidation";
    patientCreationFeatures["EXTERNAL_ID_VALIDATION"] = "externalIdValidation";
    patientCreationFeatures["INVITE_CODE"] = "inviteCode";
    patientCreationFeatures["LAST_ACR_LAB_TEST_VALIDATION"] = "latsAcrLabTestValidation";
    patientCreationFeatures["MOBILE_NUMBER_VALIDATION"] = "mobileNumberValidation";
    patientCreationFeatures["OLD_RENEWAL"] = "oldRenewal";
    patientCreationFeatures["PARTNER_EXTERNAL_DATA"] = "partnerExternalData";
    patientCreationFeatures["RENEWAL"] = "renewal";
    patientCreationFeatures["TEST_PATIENT"] = "testPatient";
    patientCreationFeatures["TIME_ZONE"] = "timeZone";
})(patientCreationFeatures || (exports.patientCreationFeatures = patientCreationFeatures = {}));
